import { Chip } from '@mui/material';

import sortBy from 'lodash/sortBy';

import { TrainingJobStatus } from '@/graphql';
import {
  MAP_STATUS_GROUP_TO_COLOR,
  MAP_STATUS_GROUP_TO_ICON,
  ORDERED_STATUS_GROUPS,
  TrainingJobStatusGroup,
  mapTrainingJobStatusToGroup,
} from '@/sections/Training/utils';

import { TrainingJobByStatusCountFragment } from './__generated__/fragments.generated';

function mapTrainingJobsCountByStatusToChips(
  jobsCountByStatus: TrainingJobByStatusCountFragment[],
) {
  const jobsCountByStatusGroup = jobsCountByStatus.reduce((acc, job) => {
    const statusGroup = mapTrainingJobStatusToGroup(job.status as TrainingJobStatus);
    acc[statusGroup] = (acc[statusGroup] || 0) + job.count;
    return acc;
  }, {} as Record<TrainingJobStatusGroup, number>);

  return sortBy(Object.entries(jobsCountByStatusGroup), ([statusGroup]) =>
    ORDERED_STATUS_GROUPS.indexOf(statusGroup as TrainingJobStatusGroup),
  ).map(([statusGroup, count]) => {
    const Icon = MAP_STATUS_GROUP_TO_ICON[statusGroup as TrainingJobStatusGroup];
    return (
      <Chip
        size="small"
        color={MAP_STATUS_GROUP_TO_COLOR[statusGroup as TrainingJobStatusGroup]}
        icon={<Icon />}
        key={statusGroup}
        label={count.toString()}
      />
    );
  });
}

export { mapTrainingJobsCountByStatusToChips };
